import React from 'react'
import ComputerSpecialistForm from './ComputerSpecialistForm'

export default function ComputerCreateSpecialistSlotPage ({ loading, onFinishFailed, sort, minimumAge, onFinish, civilityOptions, initialValues }) {
  return (
    <ComputerSpecialistForm
      loading={loading}
      onFinishFailed={onFinishFailed}
      sort={sort}
      minimumAge={minimumAge}
      onFinish={onFinish}
      civilityOptions={civilityOptions}
      initialValues={initialValues}
    />
  )
}
